import React from 'react'
import { dispatchAppEvent } from '../../../../lib/events'
import { SearchIcon } from '../icons/SearchIcon'

const ICON_SIZE_SM = 14

// Ein Ereignis statt eines Rückrufs: Die Titelleiste steht über `MainLayout`, das die Suche hält (#233).
const openSearch = () => dispatchAppEvent('open-search')

export const SearchButton = React.memo(({ label }: { label: string }) => (
  <button
    className="titlebar__search"
    onClick={openSearch}
    aria-label={label}
  >
    <SearchIcon size={ICON_SIZE_SM} />
  </button>
))
